import React from "react";
import fundImgCard from "../assets/FundPics/Fundpic.jpg";
import fundImgCard2 from "../assets/FundPics/FundPic1.jpg";
import LogoFund from "../assets/FundPics/LogoFund.png";
import Stamp from "../assets/FundPics/StampTrans.png";
import logo from "../assets/titlelogo.png";
import bg1 from "../assets/BackgroundImages/BG image 1.png";
import bg2 from "../assets/BackgroundImages/BG image 2.png";
import { FaChartLine, FaDollarSign, FaHandshake, FaRocket } from "react-icons/fa";
import SmallCard from "../components/SmallCard";

const Fund = () => {
  return (
    <>
      {/* Background Logo */}
      <div className="-z-10 absolute top-0 h-full opacity-4">
        <img
          src={logo}
          alt="Logo BG"
          className="h-full max-h-70 w-auto object-contain md:translate-y-20"
        />
      </div>

  {/* Background Images */}
  <div className="-z-10 absolute h-full opacity-45 right-0 translate-y-[400px]">
  <img
    src={bg1}
    alt="bg"
    className="h-full w-auto object-contain"
  />  
</div>
<div className="-z-10 absolute h-full opacity-45 left-0 translate-y-[1200px] md:translate-x-[-100px] md:translate-y-[400px]">
  <img
    src={bg2}
    alt="bg"
    className="h-full w-auto object-contain"
  />  
</div>
      <div className="p-10">
        {/* Header Section: Replaced text title with LogoFund image */}
        <div className="text-center">
          <img
          src={Stamp}
          alt="AIAURA Impact Fund"
          className="mx-auto w-auto h-32 md:h-40"
          />
          <img
            src={LogoFund}
            alt="AIAURA Impact Fund"
            className="mx-auto w-auto h-32 md:h-20"
          />
          <p className="mt-2 text-lg text-gray-400 max-w-2xl mx-auto">
          <strong>Together we are making a change- one client at a time</strong>
          </p>
        </div>

            {/* Featured Funding Section */}
            <div className="mt-12 relative w-full h-[500px] overflow-hidden">
    <img
        src={fundImgCard2}
        alt="Funding Opportunity"
        className="w-full h-[600px] object-contain rounded-xl"
        loading="lazy"
    />
    
</div>

        {/* Headline Section */}
        <div className="text-center pt-10">
          <h1 className="text-3xl md:text-4xl font-bold">
            Creating <span className="text-[#19BFB7]">Meaningful Change</span>
            — One Donation at a Time.
          </h1>
          <p className="mt-4 text-gray-400 max-w-2xl mx-auto">
            Through the AIAURA Impact Fund, we invest in causes that matter. Each quarter,
            we randomly select one of our clients to choose a charity, and we contribute on
            their behalf.
          </p>
        </div>

     

        {/* How It Works Section */}
        <div className="mt-12 flex flex-col md:flex-row items-center justify-center gap-10 bg-[#11243b] p-10 rounded-xl shadow-lg">
          <div className="md:w-1/2 pr-0 md:pr-8">
            <h3 className="text-3xl font-bold mb-6 text-white">
              How It <span className="text-[#19BFB7]">Works</span>
            </h3>
            <ul className="list-disc list-inside text-gray-300 space-y-3 text-xl">
              <li>
                <strong>We Collect Clients:</strong> Every active{" "}
                <span className="text-[#19BFB7]">AIAURA</span> client is automatically entered.
              </li>
              <li>
                <strong>A Random Selection:</strong> One company is chosen at random each quarter.
              </li>
              <li>
                <strong>They Pick a Charity:</strong> The selected company chooses a cause they care about.
              </li>
              <li>
                <strong>
                  <span className="text-[#19BFB7]">AIAURA</span> Donates:
                </strong>{" "}
                We make a meaningful contribution to the chosen charity.
              </li>
            </ul>
          </div>
          <div className="md:w-1/2 mt-4 md:mt-0 flex justify-center">
            <img
              src={fundImgCard}
              alt="How It Works Illustration"
              className="w-full max-w-md h-auto rounded-lg shadow-md"
            />
          </div>
        </div>

        {/* Why We Give Section with added image */}
        <div className="mt-12 p-10 rounded-lg bg-[#0b1e39] shadow-lg">
          <h2 className="text-3xl font-bold text-center mb-6">
            Why We <span className="text-[#19BFB7]">Give</span>
          </h2>
          <div className="flex flex-col md:flex-row items-center justify-center gap-8">
            <div className="md:w-1/2 text-center">
              <p className="text-gray-300 text-lg">
                At <span className="text-[#19BFB7]">AIAURA</span>, we believe that business success
                is about more than just growth—it's about making a positive difference in the world.
                Our commitment to connecting people with opportunities extends beyond recruitment;
                it's about supporting causes that have a meaningful impact. The AIAURA Impact Fund
                is our way of giving back. Each quarter, we donate to a charity selected by one of our
                clients, supporting causes that matter to them. Through this initiative, we not only
                strengthen our relationships with clients but also contribute to the greater good.
                We're dedicated to creating a lasting impact—one that goes beyond business and creates
                a ripple effect of change.
              </p>
            </div>
            <div className="md:w-1/2 flex justify-center">
              <img
                src={Stamp}
                alt="Impact Illustration"
                className="w-full max-w-sm h-auto rounded-lg shadow-md"
              />
            </div>
          </div>
        </div>

        {/* FAQ Section */}
        <div className="mt-12 p-10 rounded-lg bg-[#11243b] shadow-lg">
          <h2 className="text-3xl font-bold text-center mb-6">
            <span className="text-[#19BFB7]">Frequently</span> Asked Questions
          </h2>
          <div className="space-y-6 text-gray-300 text-lg">
            <div>
              <h3 className="font-semibold">How are clients selected?</h3>
              <p>
                Every quarter, all active AIAURA clients are entered into a random selection
                process. One company is chosen, and they get the opportunity to select a charity
                for our donation. The process is completely fair and transparent.
              </p>
            </div>
            <div>
              <h3 className="font-semibold">What types of charities are eligible?</h3>
              <p>
                We support registered charities that align with ethical and humanitarian values.
                The selected charity must be a recognized nonprofit organization that operates
                with transparency and accountability. While we're open to a wide range of causes,
                donations may only be made to organizations that meet these criteria.
              </p>
            </div>
            <div>
              <h3 className="font-semibold">Can I nominate a charity even if my company isn't chosen?</h3>
              <p>
                Yes! We encourage our clients to share causes they're passionate about. While only the
                selected company each quarter officially picks the recipient, we keep a list of nominated
                charities for future consideration.
              </p>
            </div>
          </div>
        </div>


  {/* Background Images */}
  <div className="-z-10 absolute h-full opacity-45 right-0 ">
  <img
    src={bg1}
    alt="bg"
    className="h-full w-auto object-contain"
  />  
</div>
<div className="-z-10 absolute h-full opacity-45 left-0">
  <img
    src={bg2}
    alt="bg"
    className="h-full w-auto object-contain"
  />  
</div>
        {/* Closing CTA Section */}
        <div className="mt-12 text-center">
          <h2 className="text-3xl font-bold mb-4">
            Join Us in Driving Positive Change
          </h2>
          <p className="text-gray-400 mb-6 max-w-2xl mx-auto">
            AIAURA is committed to making an impact beyond business. Together, we can create a ripple
            effect of change that transforms communities and supports meaningful causes.
          </p>
        </div>
        <div className="mt-12 relative w-full h-[200px] overflow-hidden">
    <img
        src={Stamp}
        alt="Funding Opportunity"
        className="w-full h-[100px] object-contain rounded-xl"
        loading="lazy"
    />
    
</div>
      </div>

      <SmallCard />
    </>
  );
};

export default Fund;
